/* Andy Cooks – home page v2 (sections/ac-home-v2.liquid): recipe rows, Featured paging, shop quick-add pop-up, YouTube videos with views. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ach3]');
  if (!root || root.dataset.h3Init) return;
  root.dataset.h3Init = '1';
  var acT = function (k, f) { return (window.AC_I18N && window.AC_I18N[k]) || f; };
  var ta = document.createElement('textarea');
  function dec(s) { ta.innerHTML = String(s == null ? '' : s); return ta.value; }
  var T = {};
  try { var raw = JSON.parse((document.querySelector('[data-h3-txt]') || {}).textContent || '{}'); for (var k in raw) T[k] = dec(raw[k]); } catch (e) {}
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var ARR = '<button type="button" class="h3-arr" data-dir="-1" aria-label="' + esc(T.back) + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 12H5M11 6l-6 6 6 6"/></svg></button>' +
    '<button type="button" class="h3-arr" data-dir="1" aria-label="' + esc(T.fwd) + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button>';
  var CLOCK = '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>';

  /* ---------------- recipes ---------------- */
  var A;
  function card(r) {
    return '<a class="rh-card" href="' + A.esc(r.u) + '"><span class="rh-card__img">' +
      (r.i ? '<img src="' + A.esc(A.img(r.i, 640)) + '" alt="" loading="lazy" width="640" height="640">' : '') +
      (r.v ? '<span class="rh-card__vid" aria-label="' + esc(T.video) + '"><svg viewBox="0 0 24 24"><path d="M8 5.5v13l11-6.5z"/></svg></span>' : '') + '</span>' +
      '<span class="rh-card__body"><span class="rh-card__title">' + A.esc(r.t) + '</span><span class="rh-card__meta">' +
      (r.m ? '<span class="rh-card__time">' + CLOCK + A.mins(r.m) + '</span>' : '') +
      (r.rc ? '<span class="rh-card__rate">' + A.stars(r) + '</span>' : '') + '</span></span></a>';
  }
  function bigCard(r) {
    return '<a class="rh-card h3-big" href="' + A.esc(r.u) + '"><span class="rh-card__img">' + (r.i ? '<img src="' + A.esc(A.img(r.i, 1000)) + '" alt="" loading="lazy" width="1000" height="1000">' : '') + '</span>' +
      '<span class="rh-card__body"><span class="h3-big__top"><span class="rh-card__title">' + A.esc(r.t) + '</span>' + (r.m ? '<span class="rh-card__time">' + CLOCK + A.mins(r.m) + '</span>' : '') + '</span>' +
      (r.rc ? '<span class="rh-card__meta"><span class="rh-card__rate">' + A.stars(r) + '</span></span>' : '') + '</span></a>';
  }
  function row(title, sub, list, href) {
    if (list.length < 4) return '';
    return '<section class="rh-row"><div class="h3-head"><div><h2 class="h3-h">' + esc(title) + '</h2>' + (sub ? '<p class="h3-sub">' + esc(sub) + '</p>' : '') + '</div>' +
      '<div class="h3-acts">' + ARR + '<a class="h3-all" href="' + href + '">' + esc(T.all) + '</a></div></div>' +
      '<div class="rh-row__track">' + list.slice(0, 12).map(card).join('') + '</div></section>';
  }
  function byNew(a, b) { return b.d - a.d; }
  function byReviews(a, b) { return (b.rc - a.rc) || (b.rv - a.rv) || byNew(a, b); }
  function byLoved(a, b) { return (b.rv * Math.log(1 + b.rc)) - (a.rv * Math.log(1 + a.rc)); }

  var pool = [], off = 0;
  var side = root.querySelector('[data-h3-side]'), big = root.querySelector('[data-h3-big]');
  function paintSide() { side.innerHTML = pool.slice(off, off + 4).map(card).join(''); }
  function render(all) {
    var withImg = all.filter(function (r) { return r.i; });
    /* featured: recipes whose tags or title match the words set in the editor */
    var words = (root.getAttribute('data-feat') || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var bigH = big.getAttribute('data-h') || '';
    var match = withImg.filter(function (r) { return words.some(function (w) { return r.tl.indexOf(w) >= 0 || r.t.toLowerCase().indexOf(w) >= 0; }); }).sort(byNew);
    if (match.length < 5) { var seen = {}; match.forEach(function (r) { seen[r.h] = 1; }); match = match.concat(withImg.slice().sort(byNew).filter(function (r) { return !seen[r.h]; })); }
    match = match.filter(function (r) { return r.h !== bigH; });
    if (!bigH && match.length) { big.innerHTML = bigCard(match[0]); match = match.slice(1); }
    pool = match.slice(0, 16); off = 0; paintSide();
    root.querySelector('[data-h3-rows1]').innerHTML = row(T.recent, T.recentSub, withImg.slice().sort(byNew), '/blogs/recipes');
    root.querySelector('[data-h3-rows2]').innerHTML =
      row(T.fav, T.favSub, withImg.filter(function (r) { return r.rc >= 3; }).sort(byLoved), '/blogs/recipes?sort=rating') +
      row(T.quick, T.quickSub, withImg.filter(function (r) { return r.m > 0 && r.m <= 30; }).sort(byReviews), '/blogs/recipes?cat=quick&sort=reviews');
  }
  (function wait(n) {
    A = window.ACIndex;
    if (!A) { if (n < 80) setTimeout(function () { wait(n + 1); }, 100); return; }
    A.load().then(render).catch(function () { side.innerHTML = ''; });
  })(0);

  /* arrows: Featured pages through its recipes; every other row scrolls */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('.h3-arr'); if (!b) return;
    var dir = +b.getAttribute('data-dir'), sec = b.closest('.h3-sec, .rh-row');
    if (sec && sec.hasAttribute('data-h3-featsec')) {
      if (pool.length <= 4) return;
      off = (off + dir * 4 + pool.length) % pool.length; if (off > pool.length - 4) off = dir > 0 ? 0 : Math.max(0, pool.length - 4);
      paintSide(); return;
    }
    var tr = sec && sec.querySelector('.rh-row__track, [data-h3-track]');
    if (tr) tr.scrollBy({ left: dir * tr.clientWidth * .9, behavior: 'smooth' });
  });

  /* ---------------- shop: add to cart + quick-add pop-up ---------------- */
  var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function addToCart(id, qty, btn) {
    var label = btn.querySelector('span') || btn, old = label.textContent;
    var err = btn.parentNode.querySelector('.h3-err'); if (err) err.remove();
    btn.classList.add('is-busy'); label.textContent = T.adding;
    return fetch(cartRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ id: +id, quantity: Math.max(1, +qty || 1) }) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        btn.classList.remove('is-busy');
        if (!res.ok) throw new Error(res.d.description || res.d.message || T.err);
        if (window.theme && theme.settings && theme.settings.cartType === 'page') { window.location = cartRoot + 'cart'; return true; }
        btn.classList.add('is-done'); label.textContent = T.added;
        setTimeout(function () { btn.classList.remove('is-done'); label.textContent = old; }, 2200);
        return res.d;
      })
      .catch(function (x) {
        btn.classList.remove('is-busy'); label.textContent = old;
        var p = document.createElement('p'); p.className = 'h3-err'; p.setAttribute('role', 'alert'); p.textContent = x.message; btn.parentNode.appendChild(p);
        return null;
      });
  }
  function opened(item, btn) { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: btn }, bubbles: true })); }

  var qa = null, lastFocus = null;
  function closeQA() { if (!qa) return; qa.remove(); qa = null; document.documentElement.classList.remove('h3-lock'); if (lastFocus) lastFocus.focus({ preventScroll: true }); }
  function openQA(handle, from) {
    var node = root.querySelector('[data-h3-p="' + handle + '"]'); if (!node) return;
    var P; try { P = JSON.parse(node.textContent); } catch (e) { return; }
    closeQA(); lastFocus = from;
    var opts = (P.o || []).filter(function (n, i) { return !(P.o.length === 1 && n === 'Title' && P.v.length === 1); });
    var first = P.v.filter(function (v) { return v.a; })[0] || P.v[0];
    qa = document.createElement('div'); qa.className = 'h3-qa'; qa.setAttribute('role', 'dialog'); qa.setAttribute('aria-modal', 'true'); qa.setAttribute('aria-label', dec(P.t));
    qa.innerHTML = '<div class="h3-qa__card"><div class="h3-qa__img">' + (P.i ? '<img src="' + esc(P.i) + '" alt="">' : '') + '</div>' +
      '<div class="h3-qa__body"><h3 class="h3-qa__t">' + esc(dec(P.t)) + '</h3><p class="h3-qa__price"></p>' +
      opts.map(function (n, i) {
        var vals = []; P.v.forEach(function (v) { if (vals.indexOf(v.o[i]) < 0) vals.push(v.o[i]); });
        return '<div class="h3-qa__opt"><label for="h3qo' + i + '">' + esc(dec(n)) + '</label><select id="h3qo' + i + '" data-i="' + i + '">' +
          vals.map(function (x) { return '<option' + (x === first.o[i] ? ' selected' : '') + '>' + esc(x) + '</option>'; }).join('') + '</select></div>';
      }).join('') +
      '<div class="h3-qa__row"><div class="h3-qa__qty"><button type="button" data-q="-1" aria-label="-">&minus;</button><input type="number" min="1" value="1" aria-label="' + esc(acT('ac.js.home.quantity', 'Quantity')) + '"><button type="button" data-q="1" aria-label="+">+</button></div>' +
      '<button type="button" class="h3-p__btn" data-qa-add><span></span></button></div>' +
      '<a class="h3-qa__more" href="' + esc(P.u) + '">' + esc(acT('ac.js.home.view_details', 'View full details')) + ' &rarr;</a></div>' +
      '<button type="button" class="h3-qa__x" data-x aria-label="' + esc(acT('ac.js.kitchen.close', 'Close')) + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>';
    document.body.appendChild(qa); document.documentElement.classList.add('h3-lock');
    var cur = first, addBtn = qa.querySelector('[data-qa-add]'), qty = qa.querySelector('input');
    function pick() {
      var chosen = [].map.call(qa.querySelectorAll('select'), function (s) { return s.value; });
      cur = P.v.filter(function (v) { return chosen.every(function (c, i) { return v.o[i] === c; }); })[0] || null;
      qa.querySelector('.h3-qa__price').innerHTML = cur ? esc(cur.p) + (cur.c ? '<s>' + esc(cur.c) + '</s>' : '') : '';
      if (cur && cur.i) qa.querySelector('.h3-qa__img').innerHTML = '<img src="' + esc(cur.i) + '" alt="">';
      var ok = !!(cur && cur.a); addBtn.disabled = !ok; addBtn.querySelector('span').textContent = ok ? T.add : T.out;
    }
    pick();
    qa.addEventListener('change', function (e) { if (e.target.tagName === 'SELECT') pick(); });
    qa.addEventListener('click', function (e) {
      if (e.target === qa || e.target.closest('[data-x]')) return closeQA();
      var q = e.target.closest('[data-q]'); if (q) { qty.value = Math.max(1, (+qty.value || 1) + +q.getAttribute('data-q')); return; }
      if (e.target.closest('[data-qa-add]') && cur && cur.a) {
        addToCart(cur.id, qty.value, addBtn).then(function (item) { if (item && item !== true) { closeQA(); opened(item, from); } });
      }
    });
    qa.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQA(); });
    (qa.querySelector('select') || addBtn).focus({ preventScroll: true });
  }
  root.addEventListener('click', function (e) {
    var q = e.target.closest('[data-h3-quick]');
    if (q) { e.preventDefault(); openQA(q.getAttribute('data-h3-quick'), q); return; }
    var a = e.target.closest('[data-h3-add]');
    if (a) { e.preventDefault(); addToCart(a.getAttribute('data-h3-add'), 1, a).then(function (item) { if (item && item !== true) opened(item, a); }); }
  });

  /* ---------------- videos: newest uploads with length and view count ---------------- */
  var vg = root.querySelector('[data-h3-vids]'), list = root.getAttribute('data-list');
  var KEY = 'AIzaSyCLG01SJPVTGsRme3m4SCiEaen2nYtY6Eg', YT = 'https://www.googleapis.com/youtube/v3/';
  var lang = document.documentElement.lang || 'en';
  function dur(iso) {
    var m = /PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/.exec(iso || ''); if (!m) return '';
    var h = +m[1] || 0, mi = +m[2] || 0, s = +m[3] || 0, ss = (s < 10 ? '0' : '') + s;
    return h ? h + ':' + (mi < 10 ? '0' : '') + mi + ':' + ss : mi + ':' + ss;
  }
  function views(n) {
    try { return new Intl.NumberFormat(lang, { notation: 'compact', maximumFractionDigits: 1 }).format(n); } catch (e) { return String(n); }
  }
  function ago(d) {
    var days = Math.round((Date.now() - new Date(d)) / 864e5);
    try {
      var rtf = new Intl.RelativeTimeFormat(lang, { numeric: 'auto' });
      if (days < 7) return rtf.format(-days, 'day');
      if (days < 30) return rtf.format(-Math.floor(days / 7), 'week');
      if (days < 365) return rtf.format(-Math.floor(days / 30), 'month');
      return rtf.format(-Math.floor(days / 365), 'year');
    } catch (e) { return new Date(d).toLocaleDateString(); }
  }
  function fallback() {
    vg.innerHTML = '<div class="h3-v" style="grid-column:1/-1"><div class="h3-v__frame"><iframe src="https://www.youtube.com/embed/videoseries?list=' + encodeURIComponent(list) + '" title="YouTube" allow="accelerometer; autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe></div></div>';
  }
  if (vg && list) {
    fetch(YT + 'playlistItems?part=snippet&maxResults=9&playlistId=' + encodeURIComponent(list) + '&key=' + KEY)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var items = (d.items || []).filter(function (it) { return it.snippet && it.snippet.resourceId && it.snippet.title !== 'Private video'; });
        if (!items.length) throw new Error('none');
        var ids = items.map(function (it) { return it.snippet.resourceId.videoId; });
        return fetch(YT + 'videos?part=contentDetails,statistics&id=' + ids.join(',') + '&key=' + KEY).then(function (r) { return r.json(); }).catch(function () { return {}; }).then(function (x) {
          var info = {}; (x.items || []).forEach(function (v) { info[v.id] = v; });
          vg.innerHTML = items.map(function (it) {
            var s = it.snippet, id = s.resourceId.videoId, th = s.thumbnails || {}, v = info[id] || {};
            var img = (th.medium || th.high || th.standard || th.maxres || {}).url || ('https://i.ytimg.com/vi/' + id + '/hqdefault.jpg');
            var len = v.contentDetails ? dur(v.contentDetails.duration) : '', n = v.statistics && v.statistics.viewCount;
            return '<article class="h3-v"><div class="h3-v__frame"><button type="button" data-yt="' + esc(id) + '" aria-label="' + esc(String(T.play || '').split('__title__').join(s.title)) + '">' +
              '<img src="' + esc(img) + '" alt="" loading="lazy"><span class="h3-v__play"><svg viewBox="0 0 24 24"><path d="M7 4.5v15l12.5-7.5z"/></svg></span>' + (len ? '<span class="h3-v__dur">' + len + '</span>' : '') + '</button></div>' +
              '<a class="h3-v__t" href="https://www.youtube.com/watch?v=' + esc(id) + '" target="_blank" rel="noopener">' + esc(s.title) + '</a>' +
              '<span class="h3-v__m">' + (n ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>' + esc(views(+n) + ' ' + T.views) + ' &middot; ' : '') + esc(ago(s.publishedAt)) + '</span></article>';
          }).join('');
        });
      }).catch(fallback);
    vg.addEventListener('click', function (e) {
      var b = e.target.closest('[data-yt]'); if (!b) return;
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube.com/embed/' + b.getAttribute('data-yt') + '?autoplay=1&rel=0';
      f.title = b.getAttribute('aria-label'); f.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true;
      b.replaceWith(f);
    });
  }
})();
